import React, { useContext, useState, useEffect } from "react";
import { HouseContext } from "../../../context/HouseContext";
import { BsHouse, BsHouseAdd, BsHouseDash, BsHouseGear } from "react-icons/bs";

const buttosArray = [
  {
    id: 1,
    title: "Ver Propiedades",
    description: "Ver listado de todas las propiedades publicadas",
    url: "/dashboard/propiedades/ver",
    icon: <BsHouse />,
  },
  {
    id: 2,
    title: "Agregar Propiedad",
    description: "Ver todas las propiedades",
    url: "/dashboard/propiedades/agregar",
    icon: <BsHouseAdd />,
  },
  {
    id: 3,
    title: "Borrar Propiedad",
    description: "Ver todas las propiedades",
    url: "/dashboard/propiedades/ver",
    icon: <BsHouseDash />,
  },
  {
    id: 4,
    title: "Editar Propiedad",
    description: "Selecciona la propiedad que deseas editar",
    url: "/dashboard/propiedades/ver",
    icon: <BsHouseGear />,
  },
];

// Componente reutilizable para mostrar estadísticas
const StatCard = ({ count, label }) => (
  <div className="flex flex-col px-6 py-2 bg-white shadow rounded-lg overflow-hidden">
    <div className="flex flex-col items-center space-y-2">
      <div className="text-6xl font-bold tracking-tight leading-none text-primary">
        {count}
      </div>
      <div className="text-lg font-medium text-gray-600">{label}</div>
    </div>
  </div>
);

function DashboardHome() {
  const { houses } = useContext(HouseContext);
  const [stateCounts, setStateCounts] = useState({});
  const [highlightsCount, setHighlightsCount] = useState(0);
  const [totalHouses, setTotalHouses] = useState(0);

  useEffect(() => {
    // Contar cuántas casas hay en cada estado
    const counts = {};
    let featured = 0;

    houses.forEach((house) => {
      counts[house.state] = (counts[house.state] || 0) + 1;
      if (house.highlights) {
        featured += 1;
      }
    });

    setStateCounts(counts);
    setHighlightsCount(featured);
    setTotalHouses(houses.length); // Guardar total de casas
  }, [houses]);

  return (
    <div className="py-6 px-6 space-y-12 min-h-screen w-full">
      <div className="flex flex-col h-full w-full mx-auto space-y-6">
        <section className="flex flex-col mx-auto bg-white rounded-lg p-6 shadow-md space-y-6 w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full min-w-0">
            {/* Tarjeta del total */}
            <StatCard count={totalHouses} label="Total de Propiedades" />
            <StatCard count={highlightsCount} label="Propiedades Destacadas" />
            {/* Mapear estados dinámicamente */}
            {Object.entries(stateCounts).map(([state, count]) => (
              <StatCard key={state} count={count} label={state} />
            ))}
          </div>
        </section>
      </div>
      <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 bg-white divide-x w-full rounded-lg">
        {buttosArray.map((button, index) => (
          <a href={button.url}>
            <div
              key={index}
              className="flex h-full px-8 py-5 cursor-pointer text-gray-900 items-center hover:bg-gray-100 group border-b-4 border-b-transparent hover:border-l-gray-100 hover:border-b-blue-500 hover:border-b-4"
            >
              <div className="text-4xl group-hover:text-blue-600">
                {button.icon}
              </div>

              <div className="ml-3">
                <div className="font-medium leading-6 text-gray-600 group-hover:text-blue-600">
                  {button.title}
                </div>
                <div className="mt-0.5 text-sm text-gray-500">
                  {button.description}
                </div>
              </div>
            </div>
          </a>
        ))}
      </section>
    </div>
  );
}

export default DashboardHome;
